import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <ContactSection />
        <CarouselSection />
        <UpdatesSection />
        <CardsSection />
        <RankingSection />
        <FeaturesSection />
        <CommentsSection />
        <TopicsSection />
        <AboutSection />
        <AppSection />
        <MediaSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}